package com.milta.core.localization.translations.pl

import com.milta.core.localization.AdminUsersStrings

internal val AdminUsers = AdminUsersStrings(
    loading = "Ładowanie…",
    errorNoConnection = "Nie można połączyć się z serwerem — sprawdź swoje połączenie.",
    errorGeneric = "Wystąpił błąd. Spróbuj ponownie później.",
    readOnlyNotice = "🔒 Tylko podgląd — z tego ekranu nie można jeszcze tworzyć, edytować ani zawieszać kont.",
    kpiAccountsLabel = "Konta",
    kpiAccountsSubtitle = "wszystkie role łącznie",
    kpiDriversLabel = "Kierowcy",
    kpiDriversSubtitle = "bez własnego zespołu",
    kpiPatronsLabel = "Właściciele",
    kpiPatronsOrgSingular = "organizacja",
    kpiPatronsOrgPlural = "organizacje",
    kpiActiveSubsLabel = "Aktywne subskrypcje",
    kpiActiveSubsSubtitle = "aktywna + okres karencji",
    kpiAtRiskLabel = "Zagrożone",
    kpiAtRiskSubtitle = "próbny lub wygasły",
    searchPlaceholder = "Szukaj po nazwisku, emailu, organizacji…",
    expandAllAction = "Rozwiń wszystko",
    collapseAllAction = "Zwiń wszystko",
    columnAccount = "Konto",
    columnContact = "Kontakt",
    columnType = "Typ",
    columnAddedDate = "Dodano / utworzono",
    columnSubscription = "Subskrypcja",
    columnSince = "Od",
    columnRenewal = "Odn.",
    noOrganizationHeader = "Bez organizacji",
    emptySearchResult = "Żadne konto nie pasuje do tego wyszukiwania.",
    patronBadgePrefix = "Właściciel",
    createdOnPrefix = "Utworzono",
    emptyTeamMessage = "Brak kierowcy w tym zespole na razie.",
    driverBadge = "Kierowca",
    addedOnPrefix = "Dodano",
    viaOrganization = "Przez organizację",
    accountCreatedOnUnknown = "Konto utworzono —",
    renewalSingular = "odnowienie",
    renewalPlural = "odnowienia",
    subscriptionNone = "Brak",
    subscriptionActive = "Aktywna",
    subscriptionTrial = "Próbna",
    subscriptionGrace = "Karencja",
    subscriptionExpiredStatus = "Wygasła",
    subscriptionCancelled = "Anulowana",
    planOrganization = "Organizacja",
    planDriver = "Kierowca",
)
